import { add, isFirstDayOfMonth, startOfWeek } from "date-fns";
import React from "react";

import { HStack } from "@whoosh/design-system/src/components/primitive";
import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import { WeekDay } from "./WeekDay";

type WeekRowProps = {
  startDateObj: Date;
  monthDateObj: Date;
  endDate: string;
  onDatePress: (date: string) => void;
  selectedDate?: string;
  clubWeekStartsOn: NumericalDayOfWeek;
};

export const WeekRow = (props: WeekRowProps) => {
  const {
    startDateObj,
    endDate,
    onDatePress,
    selectedDate,
    monthDateObj,
    clubWeekStartsOn,
  } = props;

  const weekArray = Array(7).fill(0);

  const startDate = isFirstDayOfMonth(startDateObj)
    ? startOfWeek(startDateObj, { weekStartsOn: clubWeekStartsOn })
    : startDateObj;

  return (
    <HStack justifyContent="space-between" mb={0} style={{ marginTop: 1.5 }}>
      {weekArray.map((_, i) => {
        const curDateObj = add(startDate, { days: i });
        return (
          <WeekDay
            key={`day-${i}`}
            curDateObj={curDateObj}
            endDate={endDate}
            onDatePress={onDatePress}
            selectedDate={selectedDate}
            monthDateObj={monthDateObj}
          />
        );
      })}
    </HStack>
  );
};
